$('.buttons .solicit_car').click(function () {
    var car_id = this.id;
    $('#mod2 #id_car').val(car_id);
});
$('.buttons .solicit_car_pymes').click(function () {
    var car_id = this.id;
    $('#mod2 #id_car').val(car_id);
});

$('#blog .button_click').click(function () {
    $('#mod'+this.id).modal('show');
    /*
    var blog_id = this.id;
    $('.modal #content_modal').html('');
    $.ajax({
        url: https + "getBlog",
        method: "POST",
        data: {
            blog_id:blog_id,
            action:'getBlog'
        },
        success: function (data) {
            if(data != ''){
                $('.modal #content_modal').html(data);
                $('#modalBlog').modal('open');
            }else{
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
     */
});
$('.clickAsk').click(function () {
    $('html, body').animate({
        scrollTop: $('#ask').offset().top - 100
    }, 0);
});
$('.clickBlog').click(function () {
    if ($(window).width() > 600) {
        $('html, body').animate({
            scrollTop: $('#blog').offset().top - 100
        }, 0);
    }else{
        $('html, body').animate({
            scrollTop: $('#blog_otro').offset().top - 100
        }, 0);
    }
});
